/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';
@use '../../../../mixins';

.measures-other {
  .MuiFormControl-root {
    width: 100%;
  }

  .row > div {
    width: 50%;
  }
}
